import { render } from "./ReviewsApp.vue?vue&type=template&id=4541a8f8"
import script from "./ReviewsApp.vue?vue&type=script&lang=js"
export * from "./ReviewsApp.vue?vue&type=script&lang=js"

import "./ReviewsApp.vue?vue&type=style&index=0&id=4541a8f8&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__